import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AutoLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const rawDest = params.get("dest");

    const normalizeDest = (d) => {
      if (typeof d !== "string") return null;
      if (d.startsWith("/")) return d;
      return null;
    };

    let dest = normalizeDest(rawDest);
    if (!dest) {
      try {
        const saved = JSON.parse(
          localStorage.getItem("tsw_service_redirect_v1") || "null"
        );
        if (saved && saved.dest) dest = normalizeDest(saved.dest);
      } catch (_) {}
    }
    if (!dest) dest = "/customer/dashboard";

    if (token) {
      localStorage.setItem("token", token);

      try {
        const payload = JSON.parse(atob(token.split(".")[1] || ""));
        const customerId =
          payload.bigcommerce_customer_id ||
          payload.customer_id ||
          payload.customerId;
        if (customerId) {
          localStorage.setItem("customerId", String(customerId));
          console.log(`[AutoLogin] Customer entered from BigCommerce — customerId: ${customerId}, redirecting to: ${dest}`);
        }
      } catch (err) {
        console.error("[AutoLogin] Failed to decode JWT token:", err);
      }

      try {
        localStorage.removeItem("tsw_service_redirect_v1");
      } catch (err) {
        console.error("[AutoLogin] Failed to clear redirect from localStorage:", err);
      }

      navigate(dest, { replace: true });
    } else {
      navigate("/customer/login", { replace: true });
    }
  }, [location.search, navigate]);

  return <p>Auto logging you in...</p>;
};

export default AutoLogin;
